import {
    ApiOutlined,
    BranchesOutlined,
    ClusterOutlined,
    DollarCircleOutlined,
    FileExclamationOutlined,
    FontColorsOutlined,
    GoldOutlined,
    ReconciliationOutlined,
    ShopOutlined,
    ShoppingCartOutlined,
    ShoppingOutlined,
    TabletOutlined,
    TeamOutlined
} from '@ant-design/icons';
import {Menu} from 'antd';
import React, {useContext, useEffect, useState} from 'react';
import {Link} from "react-router-dom";
import {Context} from '../../App'
import {useTranslation} from "react-i18next";


const rootSubmenuKeys = ['1', '16', '22', '23', 'sub1', 'sub2', 'sub3', 'sub4', 'sub5', 'api', 'financeGroup', 'mobile_app'];
const Menu2 = () => {
    const {t} = useTranslation();
    const p = window.location.pathname


    function getItem(label, key, icon, children, type) {
        return {
            key,
            icon,
            children,
            label,
            type,
        };
    }


    const items_admin = [

        getItem(
            <p>{t('dictionary')}</p>, null, null, null, 'group'
        ),
        getItem(t('sales_structures'), 'sub1', <ClusterOutlined/>, [
            getItem(
                <Link to="site/sales-structure/warehouses">
                    {t('warehouses')}
                </Link>,
                '2'),
            getItem(
                <Link to="site/sales-structure/branches">
                    {t('branches')}
                </Link>
                , '3'),
            getItem(
                <Link to="site/sales-structure/distributors">
                    {t('distributors')}
                </Link>
                , '4'),
            getItem(
                <Link to="site/sales-structure/a-geography">
                    {t('geography')}
                </Link>
                , '5'),
        ]),

        getItem(t('org_structures_s'), 'sub2', <TeamOutlined/>, [
            getItem(
                <Link to="site/org-structures">
                    {t('org_structures_s')}
                </Link>,
                '6'),
            getItem(
                <Link to="site/org-structures/types">
                    {t('org_structure_types_s')}
                </Link>
                , '7'),
        ]),

        getItem(t('products'), 'sub3', <ShoppingOutlined/>, [
            getItem(
                <Link to="site/products">
                    {t('products')}
                </Link>,
                '8'),
            getItem(
                <Link to="site/products/groups">
                    {t('products_groups')}
                </Link>
                , '9'),

            getItem(
                <Link to="site/products/categories">
                    {t('products_categories')}
                </Link>
                , '10'),
        ]),

        getItem(t('trade_points'), 'sub4', <ShopOutlined/>, [
            getItem(
                <Link to="site/trade-points">
                    {t('trade_points')}
                </Link>
                , '11'),

            getItem(
                <Link to="site/routes">
                    {t('routes')}
                </Link>
                , '12'),

            getItem(
                <Link to="site/trade-points/chains">
                    {t('chains')}
                </Link>
                , '13'),

            getItem(
                <Link to="site/trade-points/types">
                    {t('trade_points_types')}
                </Link>
                , '14'),

            getItem(
                <Link to="site/trade-points/categories">
                    {t('trade_points_categories')}
                </Link>
                , '15'),
        ]),
        getItem(t('finance'), 'financeGroup', <DollarCircleOutlined />, [
            getItem(
                <Link to="site/finance/debts">
                    {t('debts')}
                </Link>
                , 'debts'),

            getItem(
                <Link to="site/finance/price-lists">
                    {t('price_lists')}
                </Link>
                , 'price_lists'),

            getItem(
                <Link to="site/finance/operation-types">
                    {t('operation_types')}
                </Link>
                , 'operation_types'),

            getItem(
                <Link to="site/finance/pay-forms">
                    {t('pay_forms')}
                </Link>
                , 'pay_forms'),


        ]),

        getItem(t('documents_settings'), 'sub5', <FileExclamationOutlined/>, [
            getItem(
                <Link to="site/documents-settings/reporting-periods">
                    {t('reporting_periods')}
                </Link>
                , '17'),

            getItem(
                <Link to="site/documents-settings/reporting-periods/types">
                    {t('types_reporting_periods')}
                </Link>
                , '18'),

            getItem(
                <Link to="site/documents-settings/pattern-activities">
                    {t('pattern_activities')}
                </Link>
                , '19'),

            getItem(
                <Link to="site/documents-settings/types">
                    {t('doc_types')}
                </Link>
                , '20'),

            getItem(
                <Link to="site/documents-settings/units">
                    {t('units')}
                </Link>
                , '21'),
        ]),

        getItem(
            <p>{t('extensions')}</p>, null, null, null, 'group'
        ),

        getItem(t('mobile_app'), 'mobile_app', <TabletOutlined />, [

            getItem(
                <Link to="site/app/availability">
                    {t('availability')}
                </Link>
                , 'availability'),

            getItem(
                <Link to="site/app/visits">
                    {t('visits')}
                </Link>
                , 'visits'),

            getItem(
                <Link to="site/app/orders">
                    {t('orders')}
                </Link>
                , 'orders'),

            getItem(
                <Link to="site/app/payments">
                    {t('payments')}
                </Link>
                , 'payments'),

            getItem(
                <Link to="site/app/returns">
                    {t('returns')}
                </Link>
                , 'returns'),
            getItem(
                <Link to="site/app/remains_trade_points">
                    {t('remains_trade_points')}
                </Link>
                , 'remains_trade_points'),
        ]),

        getItem(
            <p>{t('documents')}</p>, null, null, null, 'group'
        ),

        getItem(
            <Link to="site/documents/sales">
                {t('sales')}
            </Link>
            , '22', <ShoppingCartOutlined/>),

        getItem(
            <Link to="site/documents/remains">
                {t('remains')}
            </Link>
            , '23', <GoldOutlined/>),

        getItem(
            <p>{t('system')}</p>, null, null, null, 'group'
        ),
        getItem(<>{t('administrations')}</>, 'administrations', <FontColorsOutlined /> , [

            getItem(
                <Link to="site/admin/users">
                    {t('users')}
                </Link>,
                '24'),

            getItem(
                <Link to="site/admin/mailing">
                    {t('news_mailing')}
                </Link>,
                '27'),

            getItem(
                <Link to="site/admin/cube">
                    {t('cube')}
                </Link>,
                '28'),
        ]),

    ];

    const development = [
        getItem(
            <p>{t('development')}</p>, null, null, null, 'group'
        ),
        getItem(
            <p>{t('api')}</p>,
            'api',
            <ApiOutlined />,
            [

                getItem(
                    <Link to="site/development/documentation">
                        {t('documentation')}
                    </Link>
                    , '25'),

                getItem(
                    <Link to="site/development/logs">
                        {t('logs')}
                    </Link>
                    , '26'),
                getItem(
                    <Link to="site/development/logs_mobile">
                        {t('logs_mobile')}
                    </Link>
                    , 'logs_mobile'),
            ]),
    ]

    const items_manager = [

        getItem(
            <p>{t('dictionary')}</p>, null, null, null, 'group'
        ),

        getItem(
            <Link to="site/sales-structure/warehouses">
                {t('warehouses')}
            </Link>,
            '2', <ReconciliationOutlined/>),


        getItem(
            <Link to="site/org-structures">
                {t('org_structures_s')}
            </Link>,
            '6', <TeamOutlined/>),

        getItem(
            <Link to="site/products">
                {t('products')}
            </Link>,
            '8', <ShoppingOutlined/>),

        getItem(
            <Link to="site/trade-points">
                {t('trade_points')}
            </Link>
            , '11', <ShopOutlined/>),

        getItem(
            <Link to="site/routes">
                {t('routes')}
            </Link>
            , '12', <BranchesOutlined/>),

        getItem(t('finance'), 'financeGroup', <DollarCircleOutlined />, [
            getItem(
                <Link to="site/finance/debts">
                    {t('debts')}
                </Link>
                , 'debts'),

            getItem(
                <Link to="site/finance/price-lists">
                    {t('price_lists')}
                </Link>
                , 'price_lists'),

            getItem(
                <Link to="site/finance/pay-forms">
                    {t('pay_forms')}
                </Link>
                , 'pay_forms'),
        ]),

        getItem(
            <p>{t('extensions')}</p>, null, null, null, 'group'
        ),

        getItem(t('mobile_app'), 'mobile_app', <TabletOutlined />, [

            getItem(
                <Link to="site/app/availability">{t('availability')}</Link>,
                'availability'
            ),

            getItem(
                <Link to="site/app/visits">{t('visits')}</Link>,
                'visits'
            ),

            getItem(
                <Link to="site/app/orders">{t('orders')}</Link>,
                'orders'
            ),

            getItem(
                <Link to="site/app/payments">{t('payments')}</Link>,
                'payments'
            ),

            getItem(
                <Link to="site/app/returns">
                    {t('returns')}
                </Link>
                , 'returns'),
            getItem(
                <Link to="site/app/remains_trade_points">
                    {t('remains_trade_points')}
                </Link>
                , 'remains_trade_points'),
        ]),

        getItem(
            <p>{t('documents')}</p>, null, null, null, 'group'
        ),

        getItem(
            <Link to="site/documents/sales">
                {t('sales')}
            </Link>
            , '22', <ShoppingCartOutlined/>),

        getItem(
            <Link to="site/documents/remains">
                {t('remains')}
            </Link>
            , '23', <GoldOutlined/>),

    ]


    const {user} = useContext(Context);

    const [openKeys, setOpenKeys] = useState([]);
    const onOpenChange = (keys) => {
        const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
        if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    const [selectedKeys, setSelectedKeys] = useState([]);
    const [menuItems, setMenuItems] = useState([]);
    // const [submenuKeys, setSubmenuKeys] = useState([]);


    // const onOpenChange = (keys) => {
    //     const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    //
    //     if (submenuKeys.indexOf(latestOpenKey) === -1) {
    //         setOpenKeys(keys);
    //     } else {
    //         setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    //     }
    //
    // };


    const getCurrentMenu = () => {
        if (p.includes('/warehouses')) return '2'
        if (p.includes('/branches')) return '3'
        if (p.includes('/distributors')) return '4'
        if (p.includes('/a-geography')) return '5'
        if (p.includes('/org-structures/types')) return '7'
        if (p.includes('/org-structures')) return '6'
        if (p.includes('/products/groups')) return '9'
        if (p.includes('/products/categories')) return '10'
        if (p.includes('/products')) return '8'
        if (p.includes('/routes')) return '12'
        if (p.includes('/trade-points/chains')) return '13'
        if (p.includes('/trade-points/types')) return '14'
        if (p.includes('/trade-points/categories')) return '15'
        if (p.includes('/trade-points')) return '11'
        if (p.includes('/equipments')) return '16'
        if (p.includes('/documents-settings/reporting-periods')) return '17'
        if (p.includes('/documents-settings/reporting-periods/types')) return '18'
        if (p.includes('/documents-settings/pattern-activities')) return '19'
        if (p.includes('/documents-settings/types')) return '20'
        if (p.includes('/documents-settings/units')) return '21'
        if (p.includes('/documents/sales')) return '22'
        if (p.includes('/documents/remains')) return '23'
        if (p.includes('/admin/users')) return '24'
        if (p.includes('/admin/mailing')) return '27'
        if (p.includes('/admin/cube')) return '28'
        if (p.includes('/development/documentation')) return '25'
        if (p.includes('/development/logs_mobile')) return 'logs_mobile'
        if (p.includes('/development/logs')) return '26'
        if (p.includes('/reports/sales')) return '22'
        if (p.includes('/change_log')) return 'change_log'
        if (p.includes('/price-lists')) return 'price_lists'
        if (p.includes('/pay-forms')) return 'pay_forms'
        if (p.includes('/operation-types')) return 'operation_types'
        if (p.includes('/finance/debts')) return 'debts'
        if (p.includes('/availability')) return 'availability'
        if (p.includes('/orders')) return 'orders'
        if (p.includes('/returns')) return 'returns'
        if (p.includes('/remains_trade_points')) return 'remains_trade_points'
        if (p.includes('/visits')) return 'visits'
        if (p.includes('/payments')) return 'payments'
        if (p.includes('/')) return '1'

    }

    const getCurrentSubMenu = () => {
        if (p.includes('/sales-structure')) return 'sub1'
        if (p.includes('/org-structures')) return 'sub2'
        if (p.includes('/products')) return 'sub3'
        if (p.includes('/trade-points')) return 'sub4'
        if (p.includes('/routes')) return 'sub4'
        if (p.includes('/documents-settings')) return 'sub5'
        if (p.includes('/development')) return 'api'
        if (p.includes('/reports')) return 'reports'
        if (p.includes('/finance')) return 'financeGroup'
        if (p.includes('/app')) return 'mobile_app'
        if (p.includes('/admin')) return 'administrations'
        if (p.includes('/')) return '1'
    }

    const onClick = (e) => {
        // if (submenuKeys.includes(e.key)) {
        //     setOpenKeys([]);
        // }
        setSelectedKeys(e.key);
    };

    useEffect(() => {
        setSelectedKeys([getCurrentMenu()])
        setOpenKeys([getCurrentSubMenu()]);
    }, [])


    useEffect(() => {
        switch (user.role_id) {
            case 1 : {
                //Admin
                setMenuItems(items_admin.concat(development));
                // setSubmenuKeys(rootSubmenuKeys);
                break
            }
            case 2 : {
                //Manager
                setMenuItems(items_manager);
                break
            }
            case 3: {
                //Developer
                setMenuItems(items_manager.concat(development));
                break
            }

            default: {
                setMenuItems(items_manager);
                break
            }
        }
    }, [user])


    return (
        <>
            <Menu
                mode="inline"
                openKeys={openKeys}
                onOpenChange={onOpenChange}
                selectedKeys={selectedKeys}
                onClick={onClick}
                items={menuItems}
            />
        </>
    )
}

export default Menu2;